<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <core-table
          _hide-upsert
          title="Protocols"
          :config="config"
          upsertMaxWidth="400px">

           <template slot='headerActions'>

            <v-tooltip
              top>
              <template
                slot="activator"
                slot-scope="{ on }">

                 <v-btn
                  v-on="on"
                  v-if="$can('export', 'protocol')"
                  color="secondary"
                  :loading="loadingExport"
                  @click="exportExcel()">
                  <v-icon>mdi-file-excel</v-icon> Budget
                </v-btn>

              </template>
              <span>Export Budget Excel</span>
            </v-tooltip>        

        </template>

        </core-table>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import config from './config_index.js'
import {getList} from '@/api/base_entity.js'
import {download} from '@/api/base_entity.js'

export default {
  data () {
    return {
      config,
      loadingExport: false
    }
  },
  async mounted() {
    for (let i = 0; i < this.config.fields.length; i++) {
      if(this.config.fields[i].value=='sponsor_id') {
        const ret = await getList('sponsor')
        this.config.fields[i].list = ret.data
      }
    }
  },
  methods: {
    exportExcel() {
      this.loadingExport = true
      download('export/protocol', null, null).finally( () => {
        this.loadingExport = false
      })
    }
  }
}
</script>
